export function encodeQueryData(data: Record<string, any> = {}): string {
    const params: string[] = [];

    Object.keys(data).forEach((key) => {
        const value = data[key];
        if (value === undefined || value === null) {
            return;
        }

        if (Array.isArray(value)) {
            value.forEach(item => params.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`));
            return;
        }

        params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    });

    return params.length ? `?${params.join('&')}` : '';
}
